export default __webpack_public_path__ + "static/media/logo.f7b7cb16.png";